import SubjectModel from 'models/SubjectModel';

export default class SubjectsCollection extends Backbone.Collection {

    get model() {
        return SubjectModel
    }

    preinitialize() {
        this.constructor.type = 'subjects'
    }

    parse(response) {
        return response.subjects
    }

}
